import { createContext, useContext } from 'react';

export const DemoContext = createContext<boolean>(false);

export function useDemoMode(): boolean {
  return useContext(DemoContext);
}
